/** "1 item", "3 items", "1,200 items": a count and its noun (`many` when it isn't just the noun with "s"). */
export const plural = (n: number, one: string, many = `${one}s`) => `${n.toLocaleString()} ${n === 1 ? one : many}`;
